import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-sanity/dist/experimental/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-sanity/dist/visual-editing/client-component/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/analytics/WebVitalsReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/B2BNavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Chatbot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DisableDraftMode"] */ "/app/src/components/DisableDraftMode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/DeferredPublicFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/NavBar.tsx");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
